import React from 'react';
const pains = ['Ganas menos de $3.000 usd y no te alcanza para la vida que deseas y mereces vivir', 'Queres trabajar remoto y no sabes por dónde empezar', 'Sentís que Improvisas', 'El algoritmo "te odia"', 'Te da vergüenza grabarte', 'Estás atrapada en una rutina que no te llena y no sabes cómo salir de ahí...'];
export function IntroSection() {
  return <section className="px-6 py-12 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-91">
      <h2 className="font-serif text-4xl md:text-6xl text-brand-navy font-light mb-10" data-id="element-92">
        ¿Te identificas?
      </h2>

      <ul className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12 max-w-5xl" data-id="element-93">
        {pains.map((item, i) => <li key={i} className="flex items-start gap-3 justify-center px-2 md:justify-start" data-id="element-94">
            <span className="text-xl shrink-0 leading-snug" data-id="element-95">❌</span>
            <span className="font-medium text-brand-navy text-[17px] leading-snug max-w-[280px] text-left" data-id="element-96">
              {item}
            </span>
          </li>)}
      </ul>

      <p className="font-serif italic font-bold text-xl md:text-3xl text-brand-navy mb-3" data-id="element-97">
        Yo también estuve ahí... 💔
      </p>
      <p className="text-brand-navy font-medium leading-relaxed mb-10 md:text-xl" data-id="element-98">
        Trabajaba en una oficina de 9 a 18 hs incluidos feriados 💔
      </p>

      {/* Mirror Selfie */}
      <div className="w-full max-w-md relative mb-10" data-id="element-99">
        <div className="absolute -inset-3 bg-white rounded-[2.5rem] shadow-lg transform -rotate-2" data-id="element-100"></div>
        <img src="https://cdn.magicpatterns.com/uploads/f6Gtv3SeReAZTr37breShA/pasted-image.png" alt="Brenda creadora UGC" className="w-full h-auto rounded-3xl relative z-10 object-cover aspect-[3/4]" data-id="element-101" />
        <div className="absolute -bottom-5 -right-2 text-4xl z-20 animate-bounce" data-id="element-102">
          ✨
        </div>
      </div>

      <p className="text-brand-navy font-medium text-lg md:text-2xl leading-relaxed px-1 max-w-3xl" data-id="element-103">
        Pero eso cambió. Cuando aprendí a Crear Contenido UGC, empecé a{' '}
        <strong className="font-bold text-[#D98BAF]" data-id="element-104">FACTURAR EN GRANDE</strong>{' '}
        y cambiar mi vida por completo!
      </p>
    </section>;
}